import { Box, Loader } from '@wix/design-system';
import { StatusComplete as StatusCompleteIcon, StatusDenied as StatusDeniedIcon, Time as TimeIcon } from '@wix/wix-ui-icons-common';
import React from 'react';
import { RunTaskEntryStatus } from '../../constants';
import AiIcon from './AiIcon.svg';
export const StatusIcon = _ref => {
  let {
    status
  } = _ref;
  if (status === RunTaskEntryStatus.Loading) {
    return /*#__PURE__*/React.createElement(Box, {
      width: 24,
      height: 24,
      direction: "vertical",
      verticalAlign: "middle",
      align: "center"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    }));
  }
  if (status === RunTaskEntryStatus.Pending) {
    return /*#__PURE__*/React.createElement(TimeIcon, {
      style: {
        display: 'block',
        color: 'var(--wsr-color-Y10)'
      }
    });
  }
  if (status === RunTaskEntryStatus.Succeeded) {
    return /*#__PURE__*/React.createElement(StatusCompleteIcon, {
      style: {
        display: 'block',
        color: 'var(--wsr-color-G10)'
      }
    });
  }
  if (status === RunTaskEntryStatus.Failed) {
    return /*#__PURE__*/React.createElement(StatusDeniedIcon, {
      style: {
        display: 'block',
        color: 'var(--wsr-color-R10)'
      }
    });
  }
  if (status === RunTaskEntryStatus.Completed) {
    return /*#__PURE__*/React.createElement(Box, {
      width: 24,
      height: 24,
      align: "center",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(AiIcon, {
      style: {
        display: 'block'
      }
    }));
  }
  return null;
};
//# sourceMappingURL=StatusIcon.js.map